<div class="w-full h-full flex flex-col py-6 px-6 select-text">
  <!-- Options bar -->
  <div class="flex items-end mb-3 gap-2">
    <input type="text" class="filter-select py-2 px-3 w-70" placeholder="Enter email address..." [(ngModel)]="user_email">
    <button class="filter-select h-full w-10 border border-[var(--color-gray-500)]" (click)="get_user_activity()">
      <i class="fa-solid fa-magnifying-glass"></i>
    </button>
  </div>

  <!-- User Profile -->
  <h3 class="text-2xl font-semibold text-white mt-6 mb-4">Profile</h3>
  <div class="w-full border border-gray-700">
    <div *ngIf="profile" class="flex flex-col gap-3 py-4 px-3">
      <button (click)="show_edit_user = true" class="dark-btn w-[150px]">Edit User</button>
      <p class="text-gray-400" *ngIf="profile.alt_email"><span class="text-white font-semibold">Email:</span> {{ profile.alt_email }}</p>
      <p class="text-gray-400"><span class="text-white font-semibold">First Name:</span> {{ profile.first_name }}</p>
      <p class="text-gray-400"><span class="text-white font-semibold">Last Name:</span> {{ profile.last_name }}</p>
      <p class="text-gray-400"><span class="text-white font-semibold">Role:</span> {{ profile.role }}</p>
      <p class="text-gray-400">
        <span class="text-white font-semibold">Live Data:</span>
        <span *ngIf="profile.live_data" class="bg-green-900 text-white text-xs font-semibold py-1 px-2 rounded-sm ml-2">
          <i class="fa-solid fa-circle-check text-white mr-1"></i>
          Live
        </span>
        <span *ngIf="!profile.live_data" class="bg-red-900 text-white text-xs font-semibold py-1 px-2 rounded-sm ml-2">
          <i class="fa-solid fa-circle-xmark text-white mr-1"></i>
          Delayed
        </span>
      </p>
      <p class="text-gray-400"><span class="text-white font-semibold">Created:</span> {{ profile.created }}</p>
      <p class="text-gray-400"><span class="text-white font-semibold">Last Updated:</span> {{ profile.updated }}</p>
      <p class="text-gray-400"><span class="text-white font-semibold">Last Login:</span> {{ profile.last_login }}</p>
      <p class="text-gray-400">
        <span class="text-white font-semibold">Customers:</span>
        <span *ngFor="let customer of profile.customers" [ngClass]="{'bg-green-900': customer.active === true, 'bg-red-900': customer.active === false}" class="bg-gray-600 text-white text-xs font-semibold py-1 px-2 rounded-sm ml-2">{{ customer.name }}</span>
      </p>
      <div class="text-gray-400">
        <span class="text-white font-semibold">Scanners:</span>
        <p *ngFor="let scanner of profile.scanners" class="bg-gray-600 text-white text-xs font-semibold py-1 px-2 rounded-sm ml-2 inline-block">{{ scanner }}</p>
      </div>
      <p class="text-gray-400" *ngIf="profile.channels.length > 0">
        <span class="text-white font-semibold">Channels:</span>
        <span *ngFor="let channel of profile.channels" class="bg-gray-600 text-white text-xs font-semibold py-1 px-2 rounded-sm ml-2">{{ channel }}</span>
      </p>
    </div>
    
    <p *ngIf="!profile" class="text-center text-sm text-gray-300 py-10">Profile details are not available.</p>
  </div>

  <!-- User Activity Log -->
  <h3 class="text-2xl font-semibold text-white mt-10 mb-4">Activity Log</h3>
  <div class="w-full">
    <ag-grid-angular
      class="flex-1 w-full h-[600px]"
      [theme]="theme"
      [gridOptions]="grid.options"
      [columnDefs]="grid.columnDefs"
      [rowData]="data"
      [statusBar]="grid.statusBar"
      (gridReady)="on_grid_ready($event)"
      (modelUpdated)="on_model_updated($event)"
      (rowSelected)="on_row_selected($event)"
    />
  </div>
</div>


<!-- Edit User Modal -->
<div
  *ngIf="show_edit_user"
  class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-full max-h-full
  flex flex-col justify-center items-center
  dark:bg-[rgba(1,1,1,0.8)]"
>
  <div class="relative flex-0 w-auto p-6 bg-white min-h-[600px] overflow-y-auto">
    <i (click)="show_edit_user = false" class="fa-solid fa-xmark text-xl absolute top-2 right-2 cursor-pointer opacity-50 hover:opacity-100"></i>
    <h1 class="py-4 px-8 text-md font-semibold leading-tight tracking-tight text-gray-900 text-center md:text-2xl dark:text-white
    dark:bg-app-black-100">
      <i class="fa-solid fa-pen-to-square text-app-teal-100 mr-2"></i>
      Edit User
    </h1>
    <div class="flex flex-col gap-6 mt-6">
      <div class="flex items-center gap-2">
        <p class="font-semibold">First Name:</p>
        <input type="text" [(ngModel)]="updated_user.profile.first_name" class="input">
      </div>
      <div class="flex items-center gap-2">
        <p class="font-semibold">Last Name:</p>
        <input type="text" [(ngModel)]="updated_user.profile.last_name" class="input">
      </div>
      <div class="flex items-center gap-2">
        <p class="font-semibold">Role:</p>
        <select name="user-role" [(ngModel)]="updated_user.profile.role" class="input">
          <option value="admin">Admin</option>
          <option value="client">Client</option>
          <option value="member">Member</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <p class="font-semibold">Live Data:</p>
        <select name="live-data" [(ngModel)]="updated_user.profile.live_data" class="input">
          <option value="true">Live</option>
          <option value="false">Delayed</option>
        </select>
      </div>
      <div>
        <p class="font-semibold mb-2">Customers:</p>
        <div class="flex flex-col gap-2">
          <div *ngFor="let customer of customers" class="flex items-center gap-2">
            <input
              [value]="customer"
              [checked]="updated_user.customers.includes(customer)"
              (change)="on_user_customer_change(customer, $event)"
              type="checkbox"
            >
            <p>{{ customer }}</p>
          </div>
        </div>
      </div>
      <div>
        <p class="font-semibold mb-2">Scanners:</p>
        <div class="flex flex-col gap-2">
          <div *ngFor="let scanner of filtered_scanners" class="flex items-center gap-2">
            <input
              [value]="scanner.Id"
              [checked]="updated_user.scanners.includes(scanner.Id)"
              (change)="on_user_scanner_change(scanner.Id, $event)"
              type="checkbox"
            >
            <p>{{ scanner.Name }}</p>
          </div>
        </div>
      </div>
    </div>
    <button (click)="update_user_attributes()" class="dark-btn-primary w-full mt-8">Update User</button>
  </div>
</div>